import { render, staticRenderFns } from "./LmsFeedSocial.vue?vue&type=template&id=45114a2f&scoped=true"
import script from "./LmsFeedSocial.vue?vue&type=script&lang=js"
export * from "./LmsFeedSocial.vue?vue&type=script&lang=js"
import style0 from "./LmsFeedSocial.vue?vue&type=style&index=0&id=45114a2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45114a2f",
  null
  
)

export default component.exports